// ── Shared customizable WhatsApp template (user 2026-06-21) ──────────────────
// One editable template, persisted to localStorage, used by BOTH the Simple
// calculator (residentialSolarCalculatorV2) and the Advanced ROI Searcher
// (advanced/RoiSearcherView). Editing it in either place updates both, because
// they read/write the SAME localStorage key. {placeholders} are filled per
// selected option from each calculator's own computed numbers (no drift).

export const WA_TEMPLATE_KEY = 'rscCustomWaTemplate';

export const WA_TEMPLATE_PLACEHOLDERS = ['name', 'optLetter', 'phase', 'kwp', 'panels', 'panelWatt', 'battery', 'inverter', 'bill', 'usage', 'dayPct', 'saving', 'savingPct', 'roi', 'yield', 'cash', 'netCash', 'cashOri', 'cc36', 'netCc', 'rebate', 'promoBlock'];

export const DEFAULT_WA_TEMPLATE = `☀️ *{name}专属太阳能方案 (Option {optLetter})* ☀️

⚡ *{kwp}kWp · {panels}片 · {battery}*
省电: *RM {saving}++/月* ({savingPct}%)
回本ROI: *{roi} 年* · 回酬: *{yield}%*

🎁 价格
Installment 0% 分期: *RM {cc36}*
Cash 现金价: *RM {cash}* Only

🎉 SuRIA Home TNB回扣 RM {rebate}
{promoBlock}`;

// Read the saved template (or the default) from localStorage.
export function loadWaTemplate() {
    try { return localStorage.getItem(WA_TEMPLATE_KEY) || DEFAULT_WA_TEMPLATE; }
    catch { return DEFAULT_WA_TEMPLATE; }
}

// Persist the edited template.
export function saveWaTemplateStr(val) {
    try { localStorage.setItem(WA_TEMPLATE_KEY, val); } catch { /* ignore */ }
}

// Replace {key} tokens from a vars dict (missing keys → empty string).
export function fillWaTemplate(tpl, vars) {
    return String(tpl).replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ''));
}
